import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { LocalStorageService } from '../../../services/local-storage.service';

// Admin-only Settings shell. One home for the admin settings areas as
// tabs (deep-linkable child routes): AI Settings, Ticket Templates,
// GitHub Issues and Personal Tokens. Replaces the previously scattered
// /admin/skills + /admin/ai-settings entries.
//
// Personal Tokens is the odd one out — it configures the signed-in
// user rather than the instance — so it sits last, and the header
// dropdown links straight to it from under the user's email.
@Component({
  selector: 'app-settings',
  imports: [RouterLink, RouterLinkActive, RouterOutlet],
  templateUrl: './settings.html',
})
export class Settings implements OnInit {
  tabs = [
    { path: 'ai', label: 'AI Settings' },
    { path: 'templates', label: 'Ticket Templates' },
    { path: 'github', label: 'GitHub Issues' },
    { path: 'tokens', label: 'Personal Tokens' },
  ];

  constructor(
    private ls: LocalStorageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Belt-and-braces: the route guard already enforces the role, but
    // bouncing here avoids a flash for a non-admin who deep-links in.
    if (this.ls.getItem('agRealm') !== 'admins') {
      this.router.navigateByUrl('/');
    }
  }
}
